"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showToast = exports.ToastType = void 0;
const izitoast_1 = __importDefault(require("izitoast"));
var ToastType;
(function (ToastType) {
    ToastType["Info"] = "info";
    ToastType["Danger"] = "danger";
})(ToastType || (exports.ToastType = ToastType = {}));
function showToast(type, title, message) {
    let color;
    switch (type) {
        case ToastType.Danger:
            color = 'red';
            break;
        default:
            color = 'blue';
    }
    izitoast_1.default.show({
        title,
        message,
        color,
        position: 'topRight',
        closeOnClick: true,
        close: false,
        progressBar: false,
    });
}
exports.showToast = showToast;
